/* eslint-disable */
import React from "react";
import { useState, useEffect } from "react";
import tableau from "tableau-api";
import "tableau-api/";

import HeAppWrapper from "../../components/HeAppWrapper";
import "./app.scss";


var he_global = {
    loader: { loaderDiv: {}, loaderAnimation: {} },
    median_info: [],
    containerDiv: {},
    tableau_url: "",
    tableau_viz: {},
    tableau_workbook: {},
    tableau_dashboard: {},
    tableau_sheet: {}
};

function App() {
    // const [state, setState] = useState({
    //     // allScriptsLoaded: false
    // });

    useEffect(() => {
        initializeViz();
    }, []);


    return (
        <HeAppWrapper className='app-austin'>
            <div id="vizContainer" style={{ width: "100%", height: 800 }}></div>
            <div id="belowViz" style={{ backgroundColor: "#e6e6e6", paddingBottom: 10, paddingTop: 5 }} className="tableau-js-elements">
                <div style={{ display: "block" }}>
                    <div style={{ float: "left" }}>
                        <button onClick={onClearCriteria}  >
                            Clear Criteria
                        </button>
                        <button onClick={onExportImage}  >
                            Export Map Image
                        </button>
                        <a href="/wp-content/uploads/austin_wildfire_vulnerable_populations.zip" target="_blank">
                            <button >Download Shapefile</button>
                        </a>
                    </div>
                    <div style={{ float: "right" }}>
                        <a href="/wp-content/uploads/Austin-Full-Report.pdf">Full Report, including Methods, Data Sources, &amp; User Guide</a>
                    </div>
                </div>
            </div>
        </HeAppWrapper>
    );
}

export default App;

function initializeViz() {
    he_global.containerDiv = document.getElementById("vizContainer");
    he_global.tableau_url = "https://tableau.headwaterseconomics.org/views/Austin_Widfire_Vulnerability/AustinFire";
    var vizOptions = {
        hideTabs: true,
        hideToolbar: true,
        onFirstInteractive: function() {
            setGlobalVariables();
        }
    };

    he_global.tableau_viz = new window.tableau.Viz(he_global.containerDiv, he_global.tableau_url, vizOptions);

}

function setGlobalVariables() {
    he_global.tableau_workbook = he_global.tableau_viz.getWorkbook();
    he_global.tableau_dashboard = he_global.tableau_viz.getWorkbook().getActiveSheet();
    var objects = he_global.tableau_dashboard.getObjects();
    for (let i = 0; i < objects.length; i++) {
        if (objects[i].getObjectType() === "worksheet") {
            he_global.tableau_sheet = objects[i].getWorksheet();
        }
    }
}

// function setCriteriaToMedians() {
//     he_global.tableau_workbook.changeParameterValueAsync("Wildfire potential criteria", ">= Normal");
//     he_global.tableau_workbook.changeParameterValueAsync("Accuracy Choice", "INCLUSIVE: All areas that may meet criteria*");
//     he_global.tableau_workbook.changeParameterValueAsync("Families in poverty percent criteria", 7);
//     he_global.tableau_workbook.changeParameterValueAsync("People with disability percent criteria", 9);
//     he_global.tableau_workbook.changeParameterValueAsync("People under 5 criteria", 7);
//     he_global.tableau_workbook.changeParameterValueAsync("People over 65 criteria", 8);
//     he_global.tableau_workbook.changeParameterValueAsync("Speak English not well percent criteria", 3);
//     he_global.tableau_workbook.changeParameterValueAsync("Nonwhite percent criteria", 19);
//     he_global.tableau_workbook.changeParameterValueAsync("Households with no car percent criteria", 4);
//     he_global.tableau_workbook.changeParameterValueAsync("Population change criteria", 12);
// }

function onClearCriteria(e) {
    setCriteriaToZero();
}

function setCriteriaToZero() {
    he_global.tableau_workbook.changeParameterValueAsync("Wildfire potential criteria", ">= Normal");
    he_global.tableau_workbook.changeParameterValueAsync("Accuracy Choice", "RESTRICTIVE: Areas definitely meeting criteria*");
    he_global.tableau_workbook.changeParameterValueAsync("Families in poverty percent criteria", 0);
    he_global.tableau_workbook.changeParameterValueAsync("People with disability percent criteria", 0);
    he_global.tableau_workbook.changeParameterValueAsync("People under 5 criteria", 0);
    he_global.tableau_workbook.changeParameterValueAsync("People over 65 criteria", 0);
    he_global.tableau_workbook.changeParameterValueAsync("Speak English not well percent criteria", 0);
    he_global.tableau_workbook.changeParameterValueAsync("Nonwhite percent criteria", 0);
    he_global.tableau_workbook.changeParameterValueAsync("Households with no car percent criteria", 0);
    he_global.tableau_workbook.changeParameterValueAsync("Population change criteria", -100);
}

// function onResetCriteria(e) {
//     setCriteriaToMedians();
// }

function onExportImage(e) {
    he_global.tableau_viz.showExportImageDialog();
}

// function onDownloadShapefile(e) {
//     console.debug("Download a shapefile");
// }

// jQuery(window).load(initializeViz);
